import {Component, Input} from '@angular/core'

@Component({
  selector: 'split-view',
  styles: [`
    :host {
      display: block;
      height: 100%;
      width: 100%;
    }

    .bg-white {
      background-color: white!important;
    }
    .divide-right {
      border-right: 1px solid lightgray;
    }
  `],
  template: `
    <div class="container-fluid split-view-container" [class.bg-white]="topicProposing">
      <div class="row">
        <div class="col-md-6 left" [class.divide-right]="topicProposing">
          <ng-content select="[left]"></ng-content>
        </div>
        <div class="col-md-6 right" [class.bg-white]="topicProposing">
          <ng-content select="[right]"></ng-content>
        </div>
      </div>
    </div>
  `
})
export class SplitView {
  // Inputs needed for topic-proposing page, want to make more general in the future.
  @Input() topicProposing: boolean = false;
}
